<template>
	<van-empty class="base_empty">
		<template #image>
			<img class="empty_img" :src="icons[icon]" :alt="desc" :title="desc" />
		</template>
		<template #description v-if="desc">
			<span class="description_style">{{ desc }}</span>
		</template>
		<template #default>
			<span class="default_style" v-if="label">{{ label }}</span>
		</template>
	</van-empty>
</template>

<script>
export default {
    name: 'BaseEmpty',
    props: {
        desc: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        icon: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        icons: [
            require(`@/assets/img/empty_1.png`),
            require(`@/assets/img/empty_2.png`),
            require(`@/assets/img/empty_3.png`),
            require(`@/assets/img/empty_4.png`),
            require(`@/assets/img/empty_5.png`),
            require(`@/assets/img/empty_6.png`)
        ]
    })
}
</script>

<style lang="less">
.base_empty {
	.empty_img {
		width: 313px;
		object-fit: contain;
		vertical-align: middle;
	}
	.van-empty__image {
		width: 313px;
		height: auto;
	}
	.van-empty {
		padding-top: 300px;
		.van-empty__image {
			height: initial;
		}
	}
	.van-empty__description {
		font-size: 26px;
		font-weight: normal;
		line-height: 31px;
		color: #8f959e;
		margin-top: 74px !important;
	}
	.description_style {
		font-size: 40px;
		color: #000000;
		font-weight: bold;
	}
	.default_style {
		font-size: 28px;
		color: #999999;
	}
	.van-empty__bottom {
		margin-top: 28px;
	}
}
</style>
